// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import "trix"
import "@rails/actiontext"


import AOS from "aos"
import GLightbox from "glightbox"
import Swiper from "swiper"
import Isotope from "isotope-layout"
import imagesLoaded from "imagesloaded"
import PureCounter from "@srexi/purecounterjs"

// CSS
import "aos/dist/aos.css"
import "glightbox/dist/css/glightbox.css"
import "swiper/swiper-bundle.css"

// 🔴 Globals setzen VOR der Nutzung
window.AOS = AOS
window.GLightbox = GLightbox
window.Swiper = Swiper
window.Isotope = Isotope
window.imagesLoaded = imagesLoaded
window.PureCounter = PureCounter

console.log("✅ application.js loaded")
console.log("AOS:", window.AOS ? "✅ loaded" : "❌ missing")
console.log("Swiper:", window.Swiper ? "✅ loaded" : "❌ missing")
console.log("GLightbox:", window.GLightbox ? "✅ loaded" : "❌ missing")
console.log("Isotope:", window.Isotope ? "✅ loaded" : "❌ missing")

// ------------------------------------
// Turbo-safe init
// ------------------------------------
document.addEventListener("turbo:load", () => {
  // -----------------------------
  // GLightbox
  // -----------------------------
  if (window.GLightbox) GLightbox({ selector: ".glightbox" });

  // -----------------------------
  // Swiper
  // -----------------------------
  if (window.Swiper) {
    document.querySelectorAll(".init-swiper").forEach(el => {
      const configEl = el.querySelector(".swiper-config");
      if (!configEl) return;
      const config = JSON.parse(configEl.textContent.trim());
      new Swiper(el, config);
    });
  }

  // -----------------------------
  // PureCounter
  // -----------------------------
  if (window.PureCounter) new PureCounter();

  // -----------------------------
  // Isotope + AOS
  // -----------------------------
  const isoContainer = document.querySelector(".isotope-container");
  if (isoContainer && window.Isotope && window.imagesLoaded && window.AOS) {
    // Warten, bis alle Bilder geladen sind
    imagesLoaded(isoContainer, () => {
      // Isotope initialisieren
      const iso = new Isotope(isoContainer, {
        itemSelector: ".isotope-item",
        layoutMode: "masonry",
        filter: ".filter-xrm" // Nur xRM/CRM Items beim Start
      });

      // Filter Buttons
      document.querySelectorAll(".isotope-filters li").forEach(btn => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          document.querySelector(".isotope-filters .filter-active")?.classList.remove("filter-active");
          btn.classList.add("filter-active");

          iso.arrange({ filter: btn.dataset.filter });

          // AOS neu berechnen nach Filter-Änderung
          AOS.refresh();
        });
      });

      // AOS nach Layout aktualisieren
      AOS.init({ duration: 800, once: true });
      AOS.refresh();
    });
  }
});


